/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForAiAgentArtifact extends models.ScheduleExecutionParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForAiAgentArtifact");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForAiAgentArtifact.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForAiAgentArtifact>): ScheduleExecutionParameterForAiAgentArtifact {
        let obj = Object.assign(new ScheduleExecutionParameterForAiAgentArtifact(), model);
        ScheduleExecutionParameterForAiAgentArtifact.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForAiAgentArtifact>): ScheduleExecutionParameterForAiAgentArtifact {
        if (!model) return null;
        return ScheduleExecutionParameterForAiAgentArtifact.newInstance(<ScheduleExecutionParameterForAiAgentArtifact> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForAiAgentArtifact) {
        if (!obj) return;

        models.ScheduleExecutionParameterForAiAgentArtifact.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForAiAgentArtifact): boolean {
        if (models.ScheduleExecutionParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForAiAgentArtifact.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            models.BaseReportConfigurationForAiAgentArtifact.fixupPrototype(this.configuration);
        }
    }

    configuration: models.BaseReportConfigurationForAiAgentArtifact;

}
